import { useEffect, useState, useRef } from 'react';
import { Send, MessageCircle } from 'lucide-react';
import { customerApi, fmtDate } from '../../lib/api';

export default function CustomerMessages({ me }) {
  const [msgs, setMsgs] = useState([]);
  const [body, setBody] = useState('');
  const scrollRef = useRef();

  const load = () => customerApi.get('/customer/messages').then((r) => setMsgs(r.data));
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);
  useEffect(() => { scrollRef.current?.scrollTo({ top: 99999, behavior: 'smooth' }); }, [msgs]);

  const send = async () => {
    if (!body.trim()) return;
    await customerApi.post('/customer/messages', { body });
    setBody('');
    load();
  };

  return (
    <div className="fade-in" data-testid="cust-messages-page">
      <h1 className="text-3xl font-semibold mb-4">Messages</h1>
      <div className="card flex flex-col h-[calc(100vh-220px)] min-h-[500px]">
        <div ref={scrollRef} className="flex-1 p-4 overflow-y-auto space-y-3 bg-[#fafafa]">
          {msgs.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center text-center text-sm text-[#6b7280]">
              <MessageCircle size={32} className="mb-2 text-[#d4d4d4]" />
              <div>Send us a message and we'll get back to you soon.</div>
            </div>
          ) : msgs.map((m) => (
            <div key={m.message_id} className={`flex ${m.sender === 'customer' ? 'justify-end' : 'justify-start'}`}>
              <div className={`max-w-[75%] p-3 rounded-2xl ${m.sender === 'customer' ? 'bg-[#d92027] text-white' : 'bg-white border border-[#e7e7e7]'}`}>
                <div className="text-sm whitespace-pre-wrap">{m.body}</div>
                <div className={`text-[10px] mt-1 ${m.sender === 'customer' ? 'text-white/70' : 'text-[#6b7280]'}`}>{fmtDate(m.created_at)}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="p-3 border-t border-[#f3f3f3] flex gap-2">
          <input
            value={body}
            onChange={(e) => setBody(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && (e.preventDefault(), send())}
            placeholder="Type your message..."
            className="flex-1 px-3 py-2 border border-[#e7e7e7] rounded-lg text-sm"
            data-testid="cust-message-input"
          />
          <button onClick={send} className="btn-brand flex items-center gap-1" data-testid="cust-send-message"><Send size={14} /></button>
        </div>
      </div>
    </div>
  );
}
